module.exports = __webpack_public_path__ + "static/img_2314-a5df840b40e376984e72d82f339c9cef.webp";